import {Component, EventEmitter, HostListener, Input, OnDestroy, Output} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {NavigationEnd, Router} from "@angular/router";
import {filter, Subscription, take} from "rxjs";
import {Language} from "../../../models/language";
import {TranslateService} from "@ngx-translate/core";
import {UserService} from "../../../service/user.service";
import {LANG} from "../../../constants/local-storage.contant";
import {CookieUtils} from "../../../utils/cookie.utils";

@Component({
  selector: 'app-hamburger-menu',
  templateUrl: './hamburger-menu.component.html',
  styleUrls: ['./hamburger-menu.component.scss'],
  animations: [
    trigger('slideInOut', [
      state('in', style({
        transform: 'translateX(0)'
      })),
      state('out', style({
        transform: 'translateX(100%)'
      })),

      transition('out => in', [
        style({ transform: 'translateX(105%)'}),
        animate('400ms ease-out', style({ transform: 'translateX(-3%)' })),
        animate('400ms ease-out', style({ transform: 'translateX(0)' }))
      ])
    ])
  ],
})
export class HamburgerMenuComponent implements OnDestroy {
  private readonly LANGUAGE_COOKIE_DAYS = 365;
  @Input() isOpened: boolean = false;
  @Output() menuClosed = new EventEmitter<void>();

  // todo
  protected readonly pages = [
    [
      {name: 'home-page-content.homepage', routerLink: '/'},
      // {name: 'home-page-content.one_scan', routerLink: '/one-scan'},
      {name: 'home-page-content.all_products', routerLink: '/products'},
      {name: 'home-page-content.prices', routerLink: '/prices'},
      {name: 'home-page-content.about_us', routerLink: '/about-us'},
      {name: 'home-page-content.contact', routerLink: '/contact-us'},
    ]
  ];

  protected lang: string = '';
  protected isLanguageChangeOpened: boolean = false;
  protected currentRoute: string = '';
  protected hasCurrentUser: boolean = false;
  private routerUrlSubscription: Subscription;

  constructor(
    private router: Router,
    private translateService: TranslateService,
    private userService: UserService
  ) {
    if (this.userService.token) {
      this.hasCurrentUser = true;
    }
    this.routerUrlSubscription = this.subscribeRouterUrl();
  }

  ngOnDestroy() {
    this.lang = CookieUtils.getCookie(LANG) || Language.HY;
    this.routerUrlSubscription.unsubscribe();
  }

  closeMenu() {
    this.isOpened = false;
    this.menuClosed.emit();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    if(window.innerWidth > 1174) {
      this.closeMenu();
    }
  }

  changeLang(lang: string) {
    CookieUtils.setCookie(LANG, lang, { days: this.LANGUAGE_COOKIE_DAYS });
    this.translateService.use(lang);
    this.lang = lang;
    this.isLanguageChangeOpened = false;
    this.closeMenu();
  }

  isCurrentLang(lang: Language) {
    const verifiedCurrentLang = CookieUtils.getCookie(LANG) || Language.HY;
    return verifiedCurrentLang === lang;
  }

  private subscribeRouterUrl() {
    return this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      take(1)
    ).subscribe(() => {
      this.currentRoute = this.router.url;
    });
  }

  protected readonly Language = Language;
}
